import { useState, useCallback, useEffect } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { Col, Row, Button, Form, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ListGroup from "../component/ListGroup";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import SessionUtil from "../util/SessionUtil";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";

function TermsConditions() {
  const { t } = useTranslation();
  const [type, setType] = useState("USERS");
  const [termCondEn, setTermCondEn] = useState(""); // Content state
  const [termCondAr, setTermCondAr] = useState(""); // Content state
  const [isTermCondError, setIsTermCondError] = useState(false); // Content state
  const [privacyPolicyEn, setPrivacyPolicyEn] = useState(""); // Content state
  const [privacyPolicyAr, setPrivacyPolicyAr] = useState(""); // Content state

  const [isPrivacyPolicyError, setIsPrivacyPolicyError] = useState(false); // Content state
  const [validated, setValidated] = useState(false);

  const modules = {
    toolbar: [
      // Formatting options
      [{ header: [1, 2, 3, false] }], // Header levels
      ["bold", "italic", "underline", "strike"], // Text styles
      [{ list: "ordered" }, { list: "bullet" }], // Ordered and bullet lists
      [{ script: "sub" }, { script: "super" }], // Subscript/Superscript
      [{ indent: "-1" }, { indent: "+1" }], // Indent
      [{ align: [] }], // Alignment

      // Colors and fonts
      [{ color: [] }, { background: [] }], // Text and background color
      [{ font: [] }], // Font family

      // Other tools
      ["link", "image", "video", "formula"], // Media options
      ["blockquote", "code-block"], // Blockquotes and code blocks

      // Clear formatting
      ["clean"], // Remove formatting
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "script",
    "indent",
    "align",
    "color",
    "background",
    "font",
    "link",
    "image",
    "video",
    "formula",
    "blockquote",
    "code-block",
  ];
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const isLoggedIn = SessionUtil.isLoggedIn();
  const handleType = (type) => {
    setType(type);
    setData([]);
    setTermCondEn("");
    setTermCondAr("");
    setPrivacyPolicyEn("");
    setPrivacyPolicyAr("");
  };
  const getApi = useCallback(async () => {
    setLoading(true);
    let params = {
      TermsAndConditionsView: {
        EntityName: type,
      },
    };
    const res = await ApiUtil.postApi(
      ApiPath.GET_TERMS_AND_CONDITIONS,
      params,
      "POST"
    );
    if (res.IsSuccessfull) {
      if (res.Result.TermsAndConditions.length > 0) {
        setData(res.Result.TermsAndConditions[0]);
        const data = res.Result.TermsAndConditions[0];
        setTermCondEn(data.TermsAndConditionsEn);
        setTermCondAr(data.TermsAndConditionsAr);
        setPrivacyPolicyEn(data.PrivacyPolicyEn);
        setPrivacyPolicyAr(data.PrivacyPolicyAr);
      }
      setLoading(false);
    }
  }, [type]);
  useEffect(() => {
    if (isLoggedIn) {
      getApi();
    }
  }, [getApi, isLoggedIn]);

  const addEditData = useCallback(async () => {
    setLoadingSubmit(true);
    let params = {
      EntityName: type,
      TermsAndConditionsEn: termCondEn,
      TermsAndConditionsAr: termCondAr,
      PrivacyPolicyEn: privacyPolicyEn,
      PrivacyPolicyAr: privacyPolicyAr,
    };

    const res = await ApiUtil.postApi(
      data.length === 0
        ? ApiPath.CREATE_TERMS_AND_CONDITIONS
        : ApiPath.UPDATE_TERMS_AND_CONDITIONS,
      params,
      data.length === 0 ? "POST" : "PUT"
    );
    if (res.IsSuccessfull) {
      setLoadingSubmit(false);
      Swal.fire({
        icon: "success",
        title:
          data.length === 0
            ? t("Terms and Conditions and Privacy Policy created successfully")
            : t("Terms and Conditions and Privacy Policy updated successfully"),
        showConfirmButton: false,
        timer: 4000,
         customClass: {
          title: "font-14",
        },
      });
     
    }
  }, [type, data, termCondEn, termCondAr, privacyPolicyEn, privacyPolicyAr, t]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    // Custom validation for ReactQuill content
    if (!termCondEn) {
      setIsTermCondError(true);
    } else {
      setIsTermCondError(false);
    }
    if (!privacyPolicyEn) {
      setIsPrivacyPolicyError(true);
    } else {
      setIsPrivacyPolicyError(false);
    }

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true); // Ensure validation feedback shows
    if (termCondEn && privacyPolicyEn) {
      addEditData();
    }
  };
  return (
    <Row>
      <Col lg={12}>
        <ListGroup />
        <div className=" mt-4 d-flex justify-content-between gap-2">
          <p className="title">{t("Terms and Conditions")}</p>
        </div>
        <Nav variant="tabs" defaultActiveKey="user">
          <Nav.Item>
            <Nav.Link onClick={() => handleType("USERS")} eventKey="user">
              {t("User")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link onClick={() => handleType("DRIVERS")} eventKey="driver">
              {t("Driver")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link onClick={() => handleType("STORES")} eventKey="store">
              {t("Store")}
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Col>
      {!loading ? (
        <Col lg={8}>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            className="my-4"
          >
            <Form.Group className="mb-3" controlId="termCond">
              <Form.Label className="font-SemiBold font-16">
                {t("Terms and Conditions") + " " + t("In English")}
              </Form.Label>
              <ReactQuill
                value={termCondEn}
                onChange={setTermCondEn}
                modules={modules}
                formats={formats}
                placeholder="Write something amazing..."
                className={`bg-white ${
                  isTermCondError && "border border-danger"
                }`}
                required
              />
              <Form.Control.Feedback
                className={isTermCondError && "d-block"}
                type="invalid"
              >
                {t("Please enter") +
                  " " +
                  t("Terms and Conditions") +
                  " " +
                  t("In English")}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="termCond">
              <Form.Label className="font-SemiBold font-16">
                {t("Terms and Conditions") + " " + t("In Arabic")}
              </Form.Label>
              <ReactQuill
                value={termCondAr}
                onChange={setTermCondAr}
                modules={modules}
                formats={formats}
                placeholder="Write something amazing..."
                className={`bg-white`}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="privacyPolicy">
              <Form.Label className="font-SemiBold font-16">
                {t("Privacy Policy") + " " + t("In English")}
              </Form.Label>
              <ReactQuill
                value={privacyPolicyEn}
                onChange={setPrivacyPolicyEn}
                modules={modules}
                formats={formats}
                placeholder="Write something amazing..."
                className={`bg-white ${
                  isPrivacyPolicyError && "border border-danger"
                }`}
                required
              />
              <Form.Control.Feedback
                className={isPrivacyPolicyError && "d-block"}
                type="invalid"
              >
                {t("Please enter") +
                  " " +
                  t("Privacy Policy") +
                  " " +
                  t("In English")}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="privacyPolicy">
              <Form.Label className="font-SemiBold font-16">
                {t("Privacy Policy") + " " + t("In Arabic")}
              </Form.Label>
              <ReactQuill
                value={privacyPolicyAr}
                onChange={setPrivacyPolicyAr}
                modules={modules}
                formats={formats}
                placeholder="Write something amazing..."
                className={`bg-white`}
              />
            </Form.Group>
            <div className="d-flex justify-content-end">
              <Button
                aria-label="Aria label"
                type="submit"
                className="btn-main"
                disabled={loadingSubmit}
              >
                <div className="flex-gap-2 justify-content-center">
                  {data.length === 0 ? t("Save") : t("Update")}
                  {loadingSubmit && (
                    <ReactLoading
                      type={"spin"}
                      color={"#c8c8c8"}
                      height={"20px"}
                      width={"20px"}
                    />
                  )}
                </div>
              </Button>
            </div>
          </Form>
        </Col>
      ) : (
        <Col lg={12} className="loading-style">
          <ReactLoading
            type={"bars"}
            color={"#c8c8c8"}
            height={"50px"}
            width={"50px"}
          />
        </Col>
      )}
    </Row>
  );
}

export default TermsConditions;
